export const coverageTone = (input: {
  required: number
  covered: number
  criticalGap: boolean
}): 'success' | 'warning' | 'danger' | 'neutral' => {
  if (!input.required) return 'neutral'
  const ratio = input.covered / input.required
  if (input.criticalGap || ratio < 0.75) return 'danger'
  if (ratio < 1) return 'warning'
  return 'success'
}

export const coverageBarPct = (covered: number, required: number) =>
  required ? Math.min(Math.round((covered / required) * 100), 100) : 0
